

( function () {
	'use strict'; 
	// Animated hamburger menu icon
	document.querySelector('.navbar-toggler').addEventListener('click', function () {
		document.querySelector('.animated-hamburger').classList.toggle('open');
	});

	// Find columns that have the column class, this tells us they should be nested
	const findColumns = () => {
		const columns = document.querySelectorAll('.column');
		const columnCount = columns.length;
		for (let i = 0; i < columnCount; i++) { 
			// The column-${number} class tells us which column items should be grouped together in the same column
			// e.g. all items with class column-1 are nested together in a single column, so will all items with the class column-2, and so on.
			const nestedColumnItem = document.querySelectorAll(`.column-${i}`);
			nestMenuColumns(nestedColumnItem);
		}
	};

	// Create the nested column container, apply classes, styles, remove old DOM elements and append new nested columns to DOM
	const nestMenuColumns = (nestedColumnItems) => {
		const div = document.createElement('div');
		div.classList.add('nested-column');
		for (let i = 0; i < nestedColumnItems.length; i++) { 
			const item = nestedColumnItems[i];
			if(item.id && item.id.length > 0) {
				div.innerHTML += item.innerHTML
				if (i > 0) {
					item.remove();
				}
			}
			if (i === nestedColumnItems.length - 1) {
				nestedColumnItems[0].innerHTML = '';
				nestedColumnItems[0].appendChild(div)
			}
		}
	};

	// Determine if element overflows the viewport
	const isInViewport = (element) => {
		const rect = element.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	};

	const adjustMenuPosition = (menu, menuType, index) => {
		// paddingAdjustment is the added value required to match the gap between the left margin of the menu and right margin of the viewport
		// and the gap between the top margin of the menu and the bottom margin of the header
		let paddingAdjustment; 
		menuType === 'main' ? paddingAdjustment = 10 : paddingAdjustment = -5;
		const rect = menu.getBoundingClientRect();
		const padding = parseFloat(window.getComputedStyle(menu, null).getPropertyValue('padding-left')) + parseFloat(window.getComputedStyle(menu, null).getPropertyValue('padding-right'));
		const adjustment = (rect.right - window.innerWidth) + (padding + paddingAdjustment);
		const styleNode = document.createElement('style');
		const styleText = document.createTextNode(`.adjusted-menu-${index}:after { margin-left: ${adjustment - paddingAdjustment}px !important; }`);
		menu.style.marginLeft = `-${adjustment}px`;
		menu.classList.add(`adjusted-menu-${index}`);
		styleNode.appendChild(styleText);
		styleNode.id = 'custom-biocom-styles';
		document.getElementsByTagName('head')[0].appendChild(styleNode);
	};


	const processMenus = (menuType) => {
		const mainNav = document.querySelector('.main-nav .navbar-nav');
		const utilityNav = document.querySelector('.utility-menu .container-search-utility-menu .navbar-nav');
		let menu;
		menuType === 'main' ? menu = mainNav : menu = utilityNav;
		let dropdownMenus = menu.querySelectorAll('.dropdown-menu');
		const topLevelMenuItems = menu.querySelectorAll('ul.navbar-nav .nav-item');
		const menuButtonClass = document.querySelector('.menu-button');
	
		if(!menuButtonClass && menuType !== 'utility') {
			topLevelMenuItems.forEach(menuItem => { // Add custom padding for menus with no button so they align properly vertically 
				menuItem.classList.add('no-button-menu-adjusted-padding');
			});
		}

		dropdownMenus.forEach((menu, index) => {
			if (!isInViewport(menu)) {	// Detect which menus are going to overflow the viewport
				adjustMenuPosition(menu, menuType, index);
			}
		});
	};

	const setEventListener = (element) => {
		element.addEventListener('click', event =>{
			event.preventDefault();
			event.stopPropagation();
			showSubMenu(element);
		});
	};

	const showSubMenu = (element) => {
		const menu = element.querySelector('.container-mobile-submenu');
		menu.style.display = 'flex';
	};

	//mobile menu handling
	const containerMain = document.getElementById('main');
	const containerFooter = document.querySelector('.footer');
	const navbarToggler = document.querySelector('.navbar-toggler');
	const mobileNav = document.getElementById('mobile-menu-temp');
	const dropdownToggles = mobileNav.querySelectorAll('.dropdown-toggle');
	let mobileNavIsOpen = false;

	dropdownToggles.forEach(toggle => {
		toggle.addEventListener('click', event => {
			const activeItem = mobileNav.querySelector('.active');
			activeItem.classList.remove('active');
			event.target.classList.add('active');
		});
	});

	navbarToggler.addEventListener('click', event => {
		if (mobileNavIsOpen) {
			mobileNav.style.display = 'none';
			containerMain.style.display = 'block';
			containerFooter.style.display = 'block';
			mobileNavIsOpen = false;
		} else {
			mobileNav.style.display = 'block';
			containerMain.style.display = 'none';
			containerFooter.style.display = 'none';
			mobileNavIsOpen = true;
		}
	});

	window.addEventListener('resize', (event) => {
		if (document.body.clientWidth > 990) {
			mobileNav.style.display = 'none';
			containerMain.style.display = 'block';
			containerFooter.style.display = 'block';
			mobileNavIsOpen = false;
			document.querySelector('.animated-hamburger').classList.remove('open');
		}
	}, true);
	
	// Init
	findColumns();
	processMenus('main');
	processMenus('utility');
} )(); 